"use client";

import { useEffect } from 'react';
import { useAuth } from './auth-provider';

const basePath = process.env.NEXT_PUBLIC_BASE_PATH || '/driver';

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * 認証ガードコンポーネント
 * 未認証の場合はログイン画面にリダイレクト
 * ※このコンポーネントはlayout.tsxでログインページ以外のみで使用すること
 */
export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isLoggedIn, isLoading } = useAuth();

  useEffect(() => {
    // ローディング中は何もしない
    if (isLoading) return;

    // 未認証の場合はログイン画面へリダイレクト
    if (!isLoggedIn && typeof window !== 'undefined') {
      window.location.href = `${basePath}/login`;
    }
  }, [isLoggedIn, isLoading]);

  // ローディング中または未認証の場合
  if (isLoading || !isLoggedIn) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-gray-500">読み込み中...</div>
      </div>
    );
  }

  // 認証済みの場合は子コンポーネントを表示
  return <>{children}</>;
};
